/**
 * El aviso de que la guía sigue viva mientras prepara un paso.
 *
 * Preparar puede tardar: navegar a otra pantalla, descargar su código y
 * esperar a que aparezca el elemento que se va a resaltar. Durante ese rato
 * no hay nada que pintar, y antes eso dejaba la guía **invisible** — el
 * operador daba por hecho que se había cerrado, se iba a otra pantalla, y el
 * paso reaparecía allí encima.
 *
 * Sólo se monta cuando la espera se nota (ver `TourProvider`), así que en un
 * paso normal no llega a verse. Lleva salida: una guía que no puedes cerrar
 * mientras espera es una guía que te tiene secuestrado.
 */

import { motion, useReducedMotion } from 'framer-motion';
import { fadeIn, scalePop } from '@/lib/motion';
import { Spinner } from '@/components/ui';

export function TourWaiting({ onClose }: { onClose: () => void }) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.div
      role="status"
      aria-live="polite"
      data-tour-ui=""
      variants={prefersReducedMotion ? fadeIn : scalePop}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="fixed bottom-5 right-5 z-[131] flex items-center gap-3 rounded-xl border border-border bg-background px-4 py-3 shadow-[var(--shadow-dialog)]"
    >
      <Spinner size="sm" />
      <span className="text-[13px] text-muted-foreground">
        Preparando el siguiente paso…
      </span>
      <button
        type="button"
        onClick={onClose}
        className="cursor-pointer text-[12px] text-muted-foreground transition-colors hover:text-foreground"
      >
        Salir
      </button>
    </motion.div>
  );
}
